(() => {
  const hiddenClass = 'stars-badge-media-hidden';
  const filteredClass = 'stars-badge-media-filtered';

  const setElementHidden = (element, shouldHide) => {
    element.classList.toggle(hiddenClass, shouldHide);
    element.toggleAttribute('hidden', shouldHide);
    element.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
  };

  const filterBadgeGallery = (gallery, sectionId, mediaId) => {
    const activeMediaId = `${sectionId}-${mediaId}`;

    gallery.classList.add(filteredClass);

    gallery.querySelectorAll('[data-media-id]').forEach((item) => {
      setElementHidden(item, item.dataset.mediaId !== activeMediaId);
    });

    gallery.querySelectorAll('[data-target]').forEach((thumbnail) => {
      setElementHidden(thumbnail, thumbnail.dataset.target !== activeMediaId);
    });

    gallery.querySelectorAll('.slider-counter--current, .slider-counter--total').forEach((counter) => {
      counter.textContent = '1';
    });
  };

  const syncOptionMedia = (input) => {
    if (!input || input.type !== 'radio') return;

    const label = input.labels && input.labels[0];
    const mediaId = label && label.dataset ? label.dataset.optionMediaId : null;
    if (!mediaId) return;

    const variantPicker = input.closest('variant-selects');
    const sectionId = variantPicker ? variantPicker.dataset.section : null;
    const productInfo = input.closest('product-info');
    const gallery = productInfo ? productInfo.querySelector('media-gallery') : null;

    if (!sectionId || !gallery || typeof gallery.setActiveMedia !== 'function') return;

    gallery.setActiveMedia(`${sectionId}-${mediaId}`, 1);
    filterBadgeGallery(gallery, sectionId, mediaId);
  };

  document.addEventListener('change', (event) => {
    const input = event.target && event.target.matches('variant-selects input[type="radio"]')
      ? event.target
      : null;

    if (!input) return;
    window.setTimeout(() => syncOptionMedia(input), 80);
  });

  document.addEventListener('click', (event) => {
    const label = event.target && event.target.closest('variant-selects label[data-option-media-id]');
    if (!label) return;

    const inputId = label.getAttribute('for');
    const input = inputId ? document.getElementById(inputId) : null;
    window.setTimeout(() => syncOptionMedia(input), 120);
  });

  window.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('.product-form__input--badge-gallery input[type="radio"]:checked')
      .forEach((input) => window.setTimeout(() => syncOptionMedia(input), 120));
  });
})();
